import { Add, Delete, Edit, Search } from '@mui/icons-material';
import { Box, Button, Grid, Paper, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState, useRef, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import ToolTipButton from '../../TooltopButton';
import { API } from '../../../controller/api';
import { formatDate } from '../../../controller/globalFunctions';
import { DrawerContext } from '../../../controller/context/DrawerWidthContext';





export const DocumentHub = ()=>{
    const { drawerWidth } = useContext(DrawerContext);
const theme = useTheme();
    const user = JSON.parse(Cookies.get('user'));
        const userId = user.id;
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate();
    const [data, setData] = useState(null)
    const location = useLocation();
    const state = location.state;
    const token = Cookies.get('token');
    const [update, setUpdate] = useState(false)

useEffect(()=>{
    console.log(state)
    const fetchData = async ()=>{

        const response = await axios.post(`${API}/auth/refresh-user`, { token });
       

        setData(state.route === 'iq-writer'? response.data.user.documents.interviewQuestions : state.route === 'jp-writer'? response.data.user.documents?.jobPosts : state.route === 'jd-writer'? response.data.user.documents?.jobDescriptions : state.route === 'fp-genie'? response.data.user.documents.formsPolicies : state.route === 'resume-reviewer' ? response.data.user.documents?.resumeReviewer : null);

console.log(response.data.user.documents)
setLoading(false)
        
    }
    fetchData();
},[update])


const handleDelete =  async(userId, objectId)=>{
    setLoading(true)
    console.log(userId, objectId)
    console.log(state.route)
    const response = await  axios.post(`${API}/${state.route}/delete`,{userId: userId, objectId:objectId})
    if(response.data === "Deleted successfully"){
       
     
       setUpdate(!update)
    } else {
     setLoading(false)
   

     window.alert('Something went wrong. Please try again.')
    }
    
}

const handleEditJobName =  async( userId, objectId)=>{


    const newJobName = window.prompt("Please enter the new Document Name:");

// Exit if the user clicks "Cancel" or leaves input empty after trimming
if (!newJobName || newJobName.trim() === "") {
//   window.alert("No changes were made. Please provide a valid document name.");
  return;
}

try {
    setLoading(true)
  const response = await axios.post(`${API}/${state.route}/update-job-name`, {
    userId: userId,
    objectId: objectId,
    newJobName: newJobName.trim(), // Trim whitespace from valid input
  });

  if (response.data === "Job name updated successfully") {
    setUpdate(!update); // Trigger a re-render if needed
  } else {
    window.alert("Something went wrong. Please try again.");
    setLoading(false);
  }
} catch (error) {
  console.error("Error updating job name:", error);
  window.alert("Something went wrong. Please try again.");
  setLoading(false);
}
 
    
}
if(loading){
    return( <Box sx={{
        textAlign:'center',
        paddingLeft: { xs: drawerWidth === 0 ? 40 : 0, sm: drawerWidth === 0 ? 40 : 0 },
        marginTop:10}}>
        <CircularProgress size={40}/>
    </Box>)
} else {
    
return(
    <Box sx={{
        paddingLeft: { xs: drawerWidth === 0 ? 38 : 0, sm: drawerWidth === 0 ? 38 : 0 },
        marginTop:10}}>
       <Grid container spacing={2} sx={{ marginBottom: 2 , paddingRight:{xs:0, sm:4}}}>
        <Grid item xs={12} sm={9} />
        <Grid item xs={12} sm={3}>
          <Button 
            fullWidth 
            onClick={() => navigate(`/${state.route}`, { state: { route: state.route } })} 
            variant='contained' 
            sx={{ display: { xs: 'flex', sm: 'inline-flex' }, alignItems: 'center' }}
          >
            <Add /> Add New
          </Button>
        </Grid>
      </Grid>

      <Paper  sx={{margin:{xs:0, sm:4
      }}}>
      <TableContainer component={Paper} sx={{ 
        padding: 2, 
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.background.paper 
      }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[200] }}>
              <TableCell>Document Name</TableCell>
              <TableCell>Date Created</TableCell>
              {state.route === 'fp-genie' && <TableCell>Document Type</TableCell>}
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((i, index) => (
              <TableRow key={index} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell>
                  {i.documentName}
                  {state.route !== 'resume-reviewer' &&(  <ToolTipButton Icon={<Edit />} Title="Edit Document Name" onClick={() => handleEditJobName(userId, i.id)} />)}
                </TableCell>
                <TableCell>{formatDate(i.dateCreated)}</TableCell>
                {state.route === 'fp-genie' && <TableCell>{i.docType}</TableCell>}
                <TableCell>
                {state.route === 'resume-reviewer' &&(
                  <ToolTipButton 
                    onClick={() => navigate('/view-document', { state: { data: i, route: state.route } })} 
                    Icon={<Search />} 
                    Title="View Document" 
                  />)}

                  {state.route !== 'resume-reviewer' &&(
                  <ToolTipButton 
                    onClick={() => navigate('/editor', { state: { data: i, route: state.route } })} 
                    Icon={<Edit />} 
                    Title="Edit Document" 
                  />)}
                  <ToolTipButton 
                    onClick={() => handleDelete(userId, i.id)} 
                    Icon={<Delete htmlColor='tomato' />} 
                    Title="Delete Document" 
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      </Paper>
    </Box>
)
}
    
}